import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import CreateQuizPage from "./CreateQuizPage";

export default function CreateQuizPageParent({ ...props }) {
    const location = useLocation();

    useEffect(() => {
        props.setPollKeyCode(null);
    }, [location?.state?.pollType]);

    return <CreateQuizPage {...props}/>;
}